/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DidCommMessageBlobAttachmentDescriptor: core.serialization.ObjectSchema<
    serializers.DidCommMessageBlobAttachmentDescriptor.Raw,
    Truvity.DidCommMessageBlobAttachmentDescriptor
> = core.serialization.object({
    downloadUri: core.serialization.property('download_uri', core.serialization.string()),
    filename: core.serialization.string().optional(),
    id: core.serialization.string(),
    mediaType: core.serialization.property('media_type', core.serialization.string()),
    size: core.serialization.number(),
});

export declare namespace DidCommMessageBlobAttachmentDescriptor {
    export interface Raw {
        download_uri: string;
        filename?: string | null;
        id: string;
        media_type: string;
        size: number;
    }
}
